import { RaidBridgeTopbarCollectButton } from '../../features/raid-bridge/shared/RaidBridgeTopbarCollectButton.jsx';
import { PageCaptureButton } from './PageCaptureButton.jsx';
import { useSupabaseHealth } from '../hooks/useSupabaseHealth.js';

export function SupabaseStatus({ compact = false, captureConfig = null }) {
  const health = useSupabaseHealth();

  return (
    <div className={`topbar-utility-group ${compact ? 'compact' : ''}`}>
      {!compact && captureConfig ? <PageCaptureButton {...captureConfig} placement="flow" /> : null}
      <RaidBridgeTopbarCollectButton compact={compact} />
      <div
        className={`supabase-status ${health.status}${compact ? ' compact' : ''}`}
        role="status"
        aria-live="polite"
        title={health.message}
      >
        <span aria-hidden="true" />
        {compact ? 'DB' : health.message}
      </div>
    </div>
  );
}
